import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetPlansAllV2 } from "../../../../fnx/plans/planGetAllV2";
import { plansClearData } from "../../../../store/plans/actions";
export var usePlanBenefits = function (_a) {
    var triggerGetPlan = _a.triggerGetPlan, valuePlanId = _a.valuePlanId, projectId = _a.projectId, setTriggerGetPlan = _a.setTriggerGetPlan, setListBenefit = _a.setListBenefit;
    var dispatch = useDispatch();
    var _b = useGetPlansAllV2(triggerGetPlan, valuePlanId, projectId || "", function () { return setTriggerGetPlan(false); }), responsePlans = _b.responsePlans, errorPlans = _b.errorPlans, loadingPlans = _b.loadingPlans;
    useEffect(function () {
        var _a;
        if (responsePlans && responsePlans.length > 0) {
            var list = responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.map(function (item) { return ({
                benefits: item.benefits,
            }); });
            var listB = list[0].benefits;
            if (listB) {
                setListBenefit(listB);
            }
            else {
                setListBenefit([]);
            }
            dispatch(plansClearData());
        }
        else if (responsePlans && ((_a = responsePlans.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            setListBenefit([]);
            dispatch(plansClearData());
        }
    }, [responsePlans]);
    return {
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
    };
};
